import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { TESTIMONIALS } from "../../data/content";
import { SectionHead } from "./Ornament";
import { Reveal } from "../../lib/motion";

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section data-testid="testimonials-section" className="bg-cream py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.testimonials.overline} heading={S.testimonials.heading} />
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {TESTIMONIALS.map((tm, i) => (
            <Reveal key={tm.name.en} delay={(i % 2) * 0.1}>
              <figure data-testid={`testimonial-${i}`} className="relative h-full bg-ivory border border-gold/20 rounded-lg p-8 sm:p-10">
                <span className="font-serif text-6xl text-gold/40 leading-none absolute top-4 left-6">&ldquo;</span>
                <blockquote className="relative pt-6 font-serif text-lg sm:text-xl text-maroon/85 leading-relaxed italic">
                  {t(tm.quote)}
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <span className="h-px w-8 bg-gold" />
                  <div>
                    <p className="font-cinzel text-sm text-maroon">{t(tm.name)}</p>
                    <p className="text-xs text-maroon/55">{t(tm.role)}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
